import { RefreshCcw } from 'lucide-react';
import { useState } from 'react';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';

type Props = {
  disabled?: boolean;
  className?: string;
};

export default function DateMonthYearInput({ disabled, className }: Props) {
  const [date, setDate] = useState<Date | null>(null);

  const reset = () => setDate(null);

  return (
    <div className="flex items-center gap-2 w-full">
      <DatePicker
        selected={date}
        onChange={(d: Date | null) => setDate(d)}
        showMonthYearPicker
        dateFormat="MM/yyyy"
        placeholderText="mm/yyyy"
        disabled={disabled}
        wrapperClassName="w-full"
        className={`w-full ${className}`}
      />

      <button type="button" onClick={reset} className="text-[#7a3a4c]">
        <RefreshCcw size={18} />
      </button>
    </div>
  );
}
